import { Switch, Typography } from "antd";
import React, { useState } from "react";
const { Text } = Typography;
const VerifyDetails = ({ next, back }) => {
  const [isMinor, setIsMinor] = useState(false);

  return (
    <div className="verify-details-container w50">
      <h3>Verify Details</h3>

      {/* Minor Toggle */}
      <div className="minor-toggle mb1">
        <div className="d-flex align-center">
          {/* <Controller
              name="isSeniorCitizen"
              control={control}
              defaultValue={false}
              render={({ field }) => ( */}
          <Switch style={{ marginLeft: "8px", marginRight: "16px" }} />
          {/* )}
            /> */}
          <div className="d-flex flex-col">
            <Text strong>Are you investing on behalf of a minor?</Text>
          </div>
        </div>
      </div>

      {/* PAN Card Input */}
      <div className="pp-form-item">
        <label>
          PAN card number
          <sup
            style={{
              color: "red",
              fontSize: "14px",
              position: "relative",
              top: "-1px",
            }}
          >
            *
          </sup>
        </label>
        <div className="input-with-status">
          <input type="text" value="AFZPK7190K" readOnly />
          <span className="verified-badge">Verified</span>
        </div>
      </div>

      {/* Aadhar Card Input */}
      <div className="pp-form-item">
        <label>
          Aadhar number
          <sup
            style={{
              color: "red",
              fontSize: "14px",
              position: "relative",
              top: "-1px",
            }}
          >
            *
          </sup>
        </label>
        <div className="input-with-status">
          <input type="text" value="2280 9909 6058" readOnly />
          <span className="verified-badge">Verified</span>
        </div>
      </div>

      <p className="info-text mt1">
        We have fetched your details from the Centralised know customer
        repository. Kindly verify if the details shown below are correct.
      </p>

      {/* Fetched Data */}
      <div className="fetched-data">
        <div className="success-banner">
          Data pulled successfully from UIDAI
        </div>

        <div className="user-details">
          <img
            src="https://via.placeholder.com/100"
            alt="User"
            className="user-photo"
          />
          <div className="row1">
            <div className="detail">
              <label>Account Holder Name</label>
              <p>Girish</p>
            </div>
            <div className="detail">
              <label>Mobile Number</label>
              <p>+91 83743 43876</p>
            </div>
          </div>
          <div className="row1">
            <div className="detail">
              <label>Gender</label>
              <p>Male</p>
            </div>

            <div className="detail">
              <label>Date of birth</label>
              <p>08/08/1992</p>
            </div>
          </div>
          <div className="detail">
            <label>Email</label>
            <p>
              chandrashekhar123@gmail.com <span className="edit">Edit</span>
            </p>
          </div>

          <div className="detail">
            <label>Address</label>
            <p>
              Jeevan Building, Street 4, Kakaityaa Hills, Hitech city Hyderabad,
              Telegana - 500044
            </p>
          </div>
        </div>
      </div>
      <div className="mt3">
        <button type="button" className="back-btn mr2" onClick={() => back()}>
          Back
        </button>
        <button className="send-btn" onClick={() => next()}>
          Proceed
        </button>
      </div>
    </div>
  );
};

export default VerifyDetails;
